import { Autocomplete, Box, TextField } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';
import { isString, isUndefined } from 'lodash';
import { useCallback, useEffect } from 'react';
import { PuffLoader } from 'react-spinners';
import styles from '../../styles/css/LoadingInidcator.module.css';
import withTranslations from '../../utils/HighOrderComponent';
import ErrorLabel from './ErrorLabel';

const ComboBoxAutocomplete = (props) => {
  const {
      gt,
      error,
      multiple,
      id,
      data,
      textExtractor,
      changeValue,
      updateValue,
      style,
      disabled,
      label,
      required,
      helperText,
      margin,
      disableClearable = false,
      errorsHandler,
      dataLimit,
      loading,
      renderOption,
      startAdornment,
      placeholder,
      variant,
      hiddenLabel,
      optionBoxStyle,
      filterSelectedOptions,
      objectSearch,
      classNameTextField,
      multipleLimitTags,
      onClick,
      onBlur,
      inputDisabled,
      readOnly,
      freeSolo,
      filterOnInputLength,
    } = props || {},
    { Placeholders } = gt || {};
  const errorMessage = error?.[id] || (isString(error) && error) || undefined;
  const hasError = !isUndefined(errorMessage);
  const size = 'small';

  const errorRemovalHandler = useCallback(() => {
    errorsHandler?.((prevError) => {
      delete prevError[id];
      return prevError;
    });
  }, [errorsHandler, id]);

  const filterOptionsObject = {
    limit: dataLimit || 50,
  };

  if (objectSearch) {
    filterOptionsObject.stringify = (option) => {
      const onlyValues = Object.values(option);
      return JSON.stringify(onlyValues);
    };
  }

  const filterOptionsOnInputLength = (options, state) => {
    if (state.inputValue?.length < 3) {
      return options;
    }
    return createFilterOptions()(options, state);
  };

  const filterOptions = (options, state) => {
    if (filterOnInputLength) {
      return filterOptionsOnInputLength(options, state);
    }
    return createFilterOptions(filterOptionsObject)(options, state);
  };

  const selectedOptionEqualityHandler = (option, value) => {
    if (option.id && value.id) {
      return option.id === value.id;
    } else if (value.value) {
      return option.value === value.value;
    } else {
      return option === value || value === null;
    }
  };

  const defaultValue = multiple ? [] : null;

  //TODO ovo dodati i na ostala polja ako imamo setovanje bez upotrebe onChange-a
  useEffect(() => {
    hasError && updateValue && errorRemovalHandler();
  }, [hasError, updateValue, errorRemovalHandler]);

  return (
    <div className="position-relative">
      <Autocomplete
        id={`combo-box-${id}`}
        options={data || []}
        getOptionLabel={(a) => textExtractor?.(a)}
        value={updateValue || defaultValue}
        style={{ ...style, padding: 0 }}
        fullWidth
        freeSolo={!!freeSolo}
        disabled={loading || disabled}
        readOnly={readOnly}
        size={size}
        multiple={multiple}
        limitTags={multipleLimitTags}
        filterSelectedOptions={!!filterSelectedOptions}
        renderInput={(params) => {
          const inputDefaultProps = {
            ...params?.InputProps,
            placeholder,
          };
          const inputProps = multiple
            ? inputDefaultProps
            : { ...inputDefaultProps, startAdornment };

          return (
            <TextField
              {...params}
              InputLabelProps={{
                shrink: true,
              }}
              className={`${classNameTextField}`}
              label={label}
              variant={variant || 'outlined'}
              required={!!required}
              helperText={helperText}
              fullWidth
              margin={margin || 'normal'}
              error={hasError}
              InputProps={inputProps}
              hiddenLabel={!!hiddenLabel}
              onClick={onClick}
              onBlur={onBlur}
              inputProps={{
                ...params?.inputProps,
                disabled: !!inputDisabled || params?.inputProps?.disabled,
                readOnly: !!readOnly,
              }}
            />
          );
        }}
        renderOption={(props, option) => (
          <Box component="li" {...props} style={optionBoxStyle}>
            {renderOption?.(option) || textExtractor(option)}
          </Box>
        )}
        onChange={(event, selectedItem) => {
          changeValue?.(selectedItem);
          hasError && errorRemovalHandler();
        }}
        isOptionEqualToValue={selectedOptionEqualityHandler}
        disableClearable={!!disableClearable}
        filterOptions={filterOptions}
        noOptionsText={Placeholders?.noResults}
      />
      <div className={styles['member-loader-position']}>
        <PuffLoader color="#1dc4e9" loading={!!loading} size={25} />
      </div>
      <ErrorLabel error={errorMessage} />
    </div>
  );
};

export default withTranslations(ComboBoxAutocomplete);
